import React from 'react';
import {MasterLayout} from 'layout';
import { browserHistory } from 'react-router';
import { loadReCaptcha, ReCaptcha } from 'react-recaptcha-google';
import classnames from 'classnames';
import { siteKey } from 'constants/config';

class CongDanTraCuu extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: '',
      ready: false,
      onOffForm: false
    }

    this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
  }
  onChange(e) {
    this.setState({
      value: e.target.value
    });
  }

  componentDidMount() {
    loadReCaptcha();
  }

  onLoadRecaptcha() {}

  verifyCallback(response) {
    if (response) {
      this.setState({
        ready : true,
        onOffForm: true
      })
    }
  }
  handleSearch(e) {
    e.preventDefault();
    if (this.state.ready && this.state.value) {
      browserHistory.push(`/ket-qua-cong-dan-tra-cuu/${this.state.value}`);
    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="tc-search-box">
          <div className="title">
            Tra cứu đơn
          </div>
          <form onSubmit={ this.handleSearch.bind(this) }>
            <div>
              <input type="text" name="searchKey" placeholder="Nhập mã đơn..." className="tc-input" onChange={ this.onChange.bind(this) }
                value={this.state.value} disabled={this.state.onOffForm === false ? 'disabled' : ''}/>
                <ReCaptcha
                  render="explicit"
                  sitekey={siteKey}
                  verifyCallback={this.verifyCallback}
                  onloadCallback={this.onLoadRecaptcha}
                  onSuccess={token => console.log(token)}
                  onError={console.error.bind(console)}
                  hl="vi"
                />
              <button type="submit" className={classnames('tc-bt button-tracuu', {
                'no-drop': !this.state.onOffForm
              })}>
                <span>Tra cứu</span>
              </button>
            </div>
          </form>
        </div>
      </MasterLayout>
    );
  }
}

export default CongDanTraCuu;



// WEBPACK FOOTER //
// ./src/components/modules/tra-cuu/CongDanTraCuu.jsx